import React from 'react';
import { routes } from '../../../../constants';
import MuiCardBase, { MuiCardCommonProps } from '../MuiCardBase/MuiCardBase';
import { Alert } from '../../../NotificationAlert/NotificationAlert';

export interface VideoMuiCardProps extends MuiCardCommonProps {
  product?: {
    name: string;
    id: string;
  }
  isNewAddMenuButtonMenu?: boolean;
  onShowNotification?: (alert: Alert) => void;
}

const VideoMuiCard: React.FC<VideoMuiCardProps> = (props) => {
  const {
    isFirstElement = false,
    product,
    ...restProps
  } = props;

  return <MuiCardBase
    {...restProps}
    isFirstElement={isFirstElement}
    contentType='video'
    link={product? {
      to: `/${routes.productPage.root}/${product.id}`,
      label: product.name,
      icon: 'book',
      hasTooltip: true,
    } : undefined}
  />;
};

export default VideoMuiCard;
